const reports = [
  {
    value: 0,
    label: '其他问题'
  },
  {
    value: 1,
    label: '标题夸张'
  },
  {
    value: 2,
    label: '低俗色情'
  },
  {
    value: 3,
    label: '错别字多'
  },
  {
    value: 4,
    label: '旧闻重复'
  },
  {
    value: 5,
    label: '广告软文'
  },
  {
    value: 6,
    label: '内容不实'
  },
  {
    value: 7,
    label: '涉嫌违法犯罪'
  },
  {
    value: 8,
    label: '侵权'
  }
]

export default reports
